





























































































































































































import { subject as an } from '@casl/ability';
import {Component, Vue} from 'vue-property-decorator';
import {TimeEntries} from "@/models/time-entries";
import {TimeEntriesService} from "@/services/time-entries-service";
import {TimeEntriesParams} from "@/models/time-entries-params";
import moment from "moment";
import jsPDF from 'jspdf';

@Component({
    name: 'TimeEntriesList'
})
export default class TimeEntriesList extends Vue {

    private timeEntries!: TimeEntries[];
    private leaveAndHolidaysTimeEntries!: TimeEntries[];

    private timeEntriesService!: TimeEntriesService;
    private timeEntriesParams!: TimeEntriesParams;
    private leaveAndHolidaysParams!: TimeEntriesParams;

    private timeEntriesTableFields: any[] = [];
    private timeEntriesTableItems: any[] = [];
    private leaveAndHolidaysTableFields: any[] = [];
    private leaveAndHolidaysTableItems: any[] = [];

    maxDate = new Date();
    timeEntriesFromFilter!: string;
    timeEntriesToFilter!: string;
    paycheckMonth = moment().format('MMMM');
    paycheckMonths = moment.months();
    paycheckYear = moment().year();

    timeEntriesCurrentPage = 1;
    timeEntriesPerPage = 15;
    paycheckCurrentPage = 1;
    paycheckPerPage = 15;
    pageOptions = [15, 50];
    sortBy = '';
    paycheckSortBy = 'project_name';
    sortDesc = true;
    paycheckSortDesc = true;
    sortDirection = 'asc';
    paycheckSortDirection = 'asc';
    filter = null;

    navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

    created() {
        this.timeEntriesService = new TimeEntriesService();
        this.timeEntriesParams = new TimeEntriesParams();
        this.timeEntriesFromFilter = this.timeEntriesParams.from.format("YYYY-MM-DD");
        this.timeEntriesToFilter = this.timeEntriesParams.to.format("YYYY-MM-DD");
        this.timeEntries = [];
        // this._timeEntriesTableFields = [];
        // this._timeEntriesTableItems = [];
        this.fetchTimeEntries();

        this.leaveAndHolidaysParams = new TimeEntriesParams(
            {
                from: moment().startOf('month'),
                to: moment().endOf('month'),
                holidayAndLeaves: true
            }
            );
        this.leaveAndHolidaysTimeEntries = [];
        // this._leaveAndHolidaysTableFields = [];
        // this._leaveAndHolidaysTableItems = [];
        this.fetchLeaveAndHolidays();
    }

    mounted() {
        this.maxDate = new Date();
    }

    private fetchTimeEntries() {
        this.timeEntriesService.getTimeEntries(this.timeEntriesParams)
        .then((response) => {
            this.timeEntries = response.data;

            this.timeEntriesTableFields = [{key: 'user_name', label: 'User', stickyColumn: true, sortable: true}];
            this.timeEntriesTableItems = [];
            this.timeEntries.forEach((timeEntry: TimeEntries) => {
                if (!(this.timeEntriesTableFields.find(f => f.key === timeEntry.spent_on))) {
                    this.timeEntriesTableFields.push({key: timeEntry.spent_on});
                }
                if (this.$ability.can('read', an('TimeEntries', timeEntry))) {  // Why do we need this?
                    // If user doesn't exists in items push it
                    if (!this.timeEntriesTableItems.find(u => u.user_name === timeEntry.user_name)) {
                        this.timeEntriesTableItems.push({user_name: timeEntry.user_name, user_address: timeEntry.user_address})
                    }
                    this.timeEntriesTableItems.filter(item => {return item.user_name == timeEntry.user_name})
                        .map(item => {
                            timeEntry.total_hours ? item[timeEntry.spent_on] = timeEntry.total_hours : item[timeEntry.spent_on] = 0;
                            if (typeof(item._cellVariants) === "undefined")
                                item._cellVariants = {}
                            if (timeEntry.total_hours == undefined || timeEntry.total_hours < 8 && (moment(timeEntry.spent_on).day() !== 6 && moment(timeEntry.spent_on).day() !== 0))
                                item._cellVariants[timeEntry.spent_on] = "danger"
                            else if (moment(timeEntry.spent_on).day() === 6 || moment(timeEntry.spent_on).day() === 0)
                                item._cellVariants[timeEntry.spent_on] = "secondary"
                            return item;
                        })
                }
            })
        })
        .catch((error) => {
            console.log(error);
        })
    }

    private fetchLeaveAndHolidays() {
        this.timeEntriesService.getTimeEntries(this.leaveAndHolidaysParams)
            .then((response) => {
                this.leaveAndHolidaysTimeEntries = response.data

                this.leaveAndHolidaysTableFields = [{key: 'project_name', label: 'Task', sortable: true}, {key: 'user_name', label: 'User', sortable: true}]
                this.leaveAndHolidaysTableItems = [];
                const rowMap = new Map();
                this.leaveAndHolidaysTimeEntries.forEach((timeEntry: TimeEntries) => {
                    //if (this.$ability.can('read', an('TimeEntries', timeEntries))) {  // Why do we need this?
                        if (!(this.leaveAndHolidaysTableFields.find(f => f.key === timeEntry.spent_on))) {
                            this.leaveAndHolidaysTableFields.push({key: timeEntry.spent_on, label: timeEntry.spent_on});
                        }
                    //}
                    //if (this.$ability.can('read', an('TimeEntries', timeEntry))) {  // Why do we need this?

                    // if (!(timeEntry.project_name === 'FESTIVITA' ||
                    //         timeEntry.project_name === 'Part-time')) {
                    if (!(timeEntry.project_name === 'Part-time')) {
                        const theMapKey = timeEntry.project_name + timeEntry.user_address;
                        if (!rowMap.has(theMapKey)) {
                            rowMap.set(theMapKey, {project_name: timeEntry.project_name, user_name: timeEntry.user_name, user_address: timeEntry.user_address, [timeEntry.spent_on]: timeEntry.hours});
                        } else {
                            const element = rowMap.get(theMapKey);
                            element[timeEntry.spent_on] = timeEntry.hours;
                            rowMap.set(theMapKey, element);
                        }
                    }
                })
                for (const value of rowMap.values()) {
                    this.leaveAndHolidaysTableItems.push(value);
                }
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public datePickerShown() {
        this.maxDate = new Date(); // I know, it's a waste, but I don't know how to change maxDate when you have a browser tab left open from the days before...
    }

    public goToTimeEntriesDetails(id: string, te_ids: string) {
        this.$router.push({name: 'timeEntriesDetails', params: {id: id}, query: {teIds: te_ids}});
    }

    public timeEntriesFilterChanged() {
        if (!this.timeEntriesFromFilter || !this.timeEntriesToFilter) {
            alert("You must select a date range");
            //this.time_entries_params = new TimeEntriesParams();
            return false;
        } else if (this.timeEntriesFromFilter > this.timeEntriesToFilter) {
            alert("From cannot be greather than To");
            //this.time_entries_params = new TimeEntriesParams();
            return false;
        }
        this.timeEntriesParams.from = moment(this.timeEntriesFromFilter, "YYYY-MM-DD");
        this.timeEntriesParams.to = moment(this.timeEntriesToFilter, "YYYY-MM-DD");
        this.fetchTimeEntries()
    }

    public leavesAndHolidaysSelectChanged() {
        this.leaveAndHolidaysParams.from = moment().month(this.paycheckMonth).year(this.paycheckYear).startOf('month');
        this.leaveAndHolidaysParams.to = moment().month(this.paycheckMonth).year(this.paycheckYear).endOf('month');
        this.fetchLeaveAndHolidays();
    }

    get timeEntriesFields() {
        return this.timeEntriesTableFields;
    }

    get timeEntriesItems() {
        return this.timeEntriesTableItems;
    }

    get leaveAndHolidaysFields() {
        return this.leaveAndHolidaysTableFields;
    }

    get leaveAndHolidaysItems() {
        return this.leaveAndHolidaysTableItems;
    }

    get payCheckYears() {
        const thisYear = moment().year();
        return Array(thisYear - (thisYear - 5)).fill('').map((v, idx) => thisYear - idx) as Array<number>;
    }

    public downloadPdf() {
        const doc = new jsPDF('landscape', 'pt', 'a4');
        const cols: any[] = [];
        this.leaveAndHolidaysTableFields.forEach(field => {
            if (field.key !== 'project_name' && field.key !== 'user_name') {
                cols.push(Vue.filter('slashedDate')(field.label).slice(0, -5));
            } else {
                cols.push(field.label);
            }
        })

        const headerConfig = cols.map(key=>{
                let colWidth = 36;
                let align = 'center';
                if (key == "Task") {
                    colWidth = 120;
                    align = 'left';
                } else if (key == "User") {
                    colWidth = 100;
                    align = 'left';
                }
                return {
                    'name': key,
                    'prompt': key,
                    'width': colWidth,
                    'align': align,
                    'padding': 0
                }
            });
        doc.text(10, 20, "Leaves and holidays (" + this.paycheckMonth + " " + this.paycheckYear + ")");
        doc.table(10, 30, this.leaveAndHolidaysTableItems.map((item) => {
            const pdfItem = {} as any;
            this.leaveAndHolidaysTableFields.forEach(field => {
                if (field.key !== 'project_name' && field.key !== 'user_name') {
                    pdfItem[Vue.filter('slashedDate')(field.label).slice(0, -5)] = item[field.label] || "" }
                }
                );
            pdfItem.Task = item.project_name;
            pdfItem.User = item.user_name;
            return pdfItem;
            }), headerConfig, {
                fontSize: 9,
                font: "sans"
            });
        doc.save("paycheckTable.pdf");
    }
}
